import React, { Component, useContext } from "react";
import PApage from "../components/PApage";

// DASHBOARD
import PAwelcome from "../components/PAwelcome";
import PAapps from "../components/dashboard/PAapps";
import PAdashboard, {
    PAdashUsers,
    PAdashPayouts,
    PAdashConnectors,
    PAdashSubsCharts,
    DashSection,
    Provided
} from '../components/PAdashboard'; // ChartSubsContext
import PAsubsCharts from "../components/subscriptions/PAsubsCharts";
import PAsolutionsNew from "../components/cards/PAsolutionsNew";
import PAsolutionsMenu from "../components/menu/PAsolutionsMenu";
import { PaSelectMultiple, ButtonOutlineWhite } from "../components/uikit2";
import {
  Button,
  Card,
  Input,
  Breadcrumbs,
  Select,
  Dropdown,
  FormGroup,
  RadioGroup,
  ContentBlock,
  Icon,
  StatusDot,
  ButtonActions,
} from "xsolla-uikit";
import { IntlProvider } from "react-intl";
import PAblue from "../components/PAblue";
import PAh2 from "../components/PAh2";
import { Switch, Route, Link } from "react-router-dom";
import PAantifraud from "../components/antifraud/PAantifraud";
import { PAdashboardNew } from "../components/dashboard/PAdashboardNew";
import { PAprojectOverview } from "../components/dashboard/PAprojectOverview";
import PAloginStats from '../components/login/PAloginStats';

export let hist = {};

export const demoProjects = [
  {
    id: "DEMO_EARLY_ACCESS",
    name: "Early Access Game Demo Project",
    type: "game",
    stage: "Planned launch Q3 2020",
    monetization: ["game_store", "subscriptions"],
    platforms: "PC, Mac, iOS",
    cards: 1,
    awards: 2,
    balance: "$13,997.67",
  },
  {
    id: "DEMO_FREE2PLAY",
    name: "Free 2 play Game Demo Project",
    type: "game",
    stage: "Launched on May 16 2019",
    monetization: ["virtual_items", "currency", "subscriptions"],
    platforms: "PC",
    cards: 2,
    awards: 3,
    balance: "$1,021,544.11",
  },
  {
    id: "DEMO_PARTEON",
    name: "Croudfunding Game Demo Project",
    type: "game",
    stage: "Launched on May 16 2019",
    monetization: ["virtual_items", "currency", "subscriptions"],
    platforms: "PC",
    cards: 2,
    awards: false,
    balance: "$1,021,544.11",
  },
];

export const dashMisha = {
  root: "dashboard",
  // title: "Dashboard",
  // extra: (
  // <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
  //   <Select
  //     align="right"
  //     name=""
  //     size="sm"
  //     options={[
  //       { label: "All projects", value: 1 },
  //       { label: "Only Project 1", value: 2 },
  //       { label: "Only Project 2", value: 3 }
  //     ]}
  //     input={{
  //       name: "widgTheme",
  //       value: 1,
  //       onChange: () => {
  //         void 0;
  //       }
  //     }}
  //   />
  // </div>
  // ),
  tabs: {
    team: {
      // label: "Main",
      slideTo: "all",
      title: "",

      component: (
        <div className="">
          {demoProjects.map((oneProject, ind) => (
            <PAprojectOverview
              key={oneProject["id"]}
              project={oneProject}
              menu={false}
              top={true}
              image={false}
              modulesMicro={false}
              modules={false}
              upgrades={true}
              teamDashboard={true}
              {...oneProject}
            />
          ))}
        </div>
      ),

      appearance: "flatten",
      noTitle: true, //TODO: тайтл страницы зарефакторить
    },

    all: {
      // label: "Main",
      slideTo: "all",
      title: "",

      components: [
        {
          appearance: "flatten",
          label: "all",
          component: (
            <div className="">
              {/* <FormGroup indentation="lg"> */}

              <PAprojectOverview project={demoProjects[0]} />

              {/* <PAblue
                title={
                  <PAh2
                    indentation="xs"
                    style={{ color: "white" }}
                    title="Level up your Xsolla integration"
                  >
                    <Link to="/start">
                      <ButtonOutlineWhite>
                        <Button appearance="outline" size="sm">
                          Show all
                        </Button>
                      </ButtonOutlineWhite>
                    </Link>
                  </PAh2>
                }
                limit={4}
                // hardlimit={true}
                product="microtransactions"
              /> */}
              {/* <br /> */}
              {/* </FormGroup> */}
            </div>
          ),
        },

        {
          label: "sales",
          title: <PAh2 title="Sales" />,
          // cta: (
          //   <div style={{ marginTop: -16, marginLeft: 4 }}>
          //     <PaSelectMultiple
          //       size="sm"
          //       autosize={true}
          //       initial={[30]}
          //       // disabled={this.disabled}
          //       align="right"
          //       name=""
          //       options={[
          //         { label: "Last week", value: 7 },
          //         { label: "Last 30 days", value: 30 },
          //         { label: "Last quarter", value: 90 },
          //       ]}
          //       searchable={false}
          //       // dock={"right"}
          //       input={{
          //         // onChange: setDefCurr,
          //         value: 30,
          //       }}
          //     />
          //   </div>
          // ),
          title: <PAh2>Sales</PAh2>,
          appearance: "flatten",
          component: (
            <div>
              <PAdashPayouts hist={hist} />
            </div>
          ),
        },

        {
          appearance: "flatten",
          border: "lg",
          label: "users",
          title: "Users",
          cta: (
            <PaSelectMultiple
              style={{ backgroundColor: "transparent" }}
              size="sm"
              handleSelect={(e)=>{

              }}
              initial={["users", "methods", "country"]}
              options={[
                { label: "Users over time", value: "users" },
                { label: "Authentication methods", value: "methods" },
                { label: "Users by country", value: "country" },
              ]}
            />
          ),
          component: (
            <div>
              <DashSection
                cols={true}
              >
              <PAloginStats  charts={[
                "time",
                'methods',
              ]} />
              <Provided product="login" />
              </DashSection>
            </div>
          ),
        },
        {
          label: "subscribers",
          title: "Subscribtions",
          appearance: "flatten",
          cta: (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              {/* <PAsubsChartsSelect/> */}
              <PaSelectMultiple
                size="sm"
                initial={["country"]}
                options={[
                  { label: "Users over time", value: "users" },
                  { label: "Authentication methods", value: "methods" },
                  { label: "Users by country", value: "country" },
                ]}
              />
            </div>
          ),
          component: (
            <div>
              <PAdashSubsCharts
                // empty={true}
                hist={hist}
                charts={["time", "plans"]}
              />
            </div>
          ),
        },

        {
          label: "connect",
          title: "Connect more apps",
          appearance: "flatten",
          component: (
            <div>
              <PAdashConnectors hist={hist} />
            </div>
          ),
        },
      ],
      appearance: "flatten",
      noTitle: true, //TODO: тайтл страницы зарефакторить
    },
    // sales: {
    //   label: "Sales",
    //   slideTo: "sales",
    //   title: "",
    //   component: <PAdashPayouts hist={hist} />,
    //   appearance: "flatten",
    //   noTitle: true //TODO: тайтл страницы зарефакторить
    // },
    modules: {
      label: "Modules",
      slideTo: "modules",
      title: "",
      component: <PAapps hist={hist} />,
      // appearance: 'flatten',
      noTitle: true, //TODO: тайтл страницы зарефакторить
    },
    // users: {
    //   label: 'Users',
    //   title: '',
    //   slideTo: 'users',
    //   component: <div><PAdashUsers hist={hist} charts = {[
    //     'time',
    //     'methods',
    //     'country'
    //   ]}/></div>,
    //   appearance: 'flatten',
    //   noTitle: true, //TODO: тайтл страницы зарефакторить
    // },
    // antifraud: {
    //   label: "Antifraud",
    //   title: "",
    //   component: <PAantifraud />,
    //   appearance: "flatten",
    //   noTitle: true //TODO: тайтл страницы зарефакторить
    // }
  },
};

export const dashFull = {
  root: "dashboard",
  // title: "Dashboard",
  // extra: (
  // <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
  //   <Select
  //     align="right"
  //     name=""
  //     size="sm"
  //     options={[
  //       { label: "All projects", value: 1 },
  //       { label: "Only Project 1", value: 2 },
  //       { label: "Only Project 2", value: 3 }
  //     ]}
  //     input={{
  //       name: "widgTheme",
  //       value: 1,
  //       onChange: () => {
  //         void 0;
  //       }
  //     }}
  //   />
  // </div>
  // ),
  tabs: {
    // all: {
    //   // label: "Main",
    //   slideTo: "all",
    //   title: "",

    //   component: <PAdashboardNew/>,

    //   appearance: "flatten",
    //   noTitle: true //TODO: тайтл страницы зарефакторить
    // },

    all: {
      // label: "Main",
      slideTo: "all",
      title: "",

      components: [
        {
          appearance: "flatten",
          label: "all",
          component: (
            <FormGroup indentation="lg">
              <PAblue
                title={
                  <PAh2
                    indentation="xs"
                    style={{ color: "white" }}
                    title="Level up your Xsolla integration"
                  >
                    <Link to="/start">
                      <ButtonOutlineWhite>
                        <Button appearance="outline" size="sm">
                          Show all
                        </Button>
                      </ButtonOutlineWhite>
                    </Link>
                  </PAh2>
                }
                limit={4}
                // hardlimit={true}
                product="microtransactions"
              />
              <br />
            </FormGroup>
          ),
        },

        {
          label: "sales",
          // title: (<PAh2 title="Sales"></PAh2>),
          // cta: <div
          //     style={{marginTop: -16, marginLeft: 4}}
          //   ><PaSelectMultiple
          //   size="sm"
          //   autosize={true}
          //   initial={[30]}
          //   // disabled={this.disabled}
          //   align="right"
          //   name=""
          //   options={[
          //     { label: "Last week", value: 7 },
          //     { label: "Last 30 days", value: 30 },
          //     { label: "Last quarter", value: 90 }
          //   ]}
          //   searchable={false}
          //   // dock={"right"}
          //   input={{
          //     // onChange: setDefCurr,
          //     value: 30
          //   }}
          // /></div>,
          // title: <PAh2>Sales</PAh2>,
          appearance: "flatten",
          component: (
            <div>
              <PAdashPayouts hist={hist} />
            </div>
          ),
        },

        {
          appearance: "flatten",
          border: "lg",
          label: "users",
          title: "Users",
          cta: (
            <PaSelectMultiple
              style={{ backgroundColor: "transparent" }}
              size="sm"
              initial={["users", "methods", "country"]}
              options={[
                { label: "Users over time", value: "users" },
                { label: "Authentication methods", value: "methods" },
                { label: "Users by country", value: "country" },
              ]}
            />
          ),
          component: (
            <div>
              <PAdashUsers
                hist={hist}
                charts={[
                  "time",
                  // 'methods',
                  "country",
                ]}
              />
              <br />
            </div>
          ),
        },
        {
          label: "subscribers",
          title: "Subscribtions",
          appearance: "flatten",
          cta: (
            <div
              style={{
                // display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <PaSelectMultiple
                size="sm"
                initial={["country"]}
                options={[
                  { label: "Users over time", value: "users" },
                  { label: "Authentication methods", value: "methods" },
                  { label: "Users by country", value: "country" },
                ]}
              />{" "}
            </div>
          ),
          component: (
            <div>
              <PAdashSubsCharts hist={hist} charts={["time", "plans"]} />
            </div>
          ),
        },

        {
          label: "connect",
          title: "Connect more apps",
          appearance: "flatten",
          component: (
            <div>
              <PAdashConnectors hist={hist} />
            </div>
          ),
        },
      ],
      appearance: "flatten",
      noTitle: true, //TODO: тайтл страницы зарефакторить
    },
    // sales: {
    //   label: "Sales",
    //   slideTo: "sales",
    //   title: "",
    //   component: <PAdashPayouts hist={hist} />,
    //   appearance: "flatten",
    //   noTitle: true //TODO: тайтл страницы зарефакторить
    // },
    // modules: {
    //   label: "Modules",
    //   slideTo: "modules",
    //   title: "",
    //   component: <PAapps hist={hist} />,
    //   // appearance: 'flatten',
    //   noTitle: true //TODO: тайтл страницы зарефакторить
    // },
    // users: {
    //   label: 'Users',
    //   title: '',
    //   slideTo: 'users',
    //   component: <div><PAdashUsers hist={hist} charts = {[
    //     'time',
    //     'methods',
    //     'country'
    //   ]}/></div>,
    //   appearance: 'flatten',
    //   noTitle: true, //TODO: тайтл страницы зарефакторить
    // },
    // antifraud: {
    //   label: "Antifraud",
    //   title: "",
    //   component: <PAantifraud />,
    //   appearance: "flatten",
    //   noTitle: true //TODO: тайтл страницы зарефакторить
    // }
  },
};

export const PAsubsChartsSelect = () => {
  // let charts = useContext(ChartSubsContext)

  return (
    <PaSelectMultiple
      size="sm"
      initial={["country"]}
      options={[
        { label: "Users over time", value: "users" },
        { label: "Authentication methods", value: "methods" },
        { label: "Users by country", value: "country" },
      ]}
    />
  );
};
